/**
 * Shared utility: lowest operational pressure dimension.
 * Used by HotelStatusStrip and IncidentBanner.
 */

import type { PulseDimensions } from '../staff/services/controlTowerTypes';

export function lowestDimension(dims: PulseDimensions): { name: string; score: number } {
  const entries: [string, number][] = [
    ['Service', dims.service],
    ['Operations', dims.operations],
    ['Infrastructure', dims.infrastructure],
    ['Sustainability', dims.sustainability],
  ];
  let lowest = entries[0]!;
  for (const entry of entries) {
    if (entry[1] < lowest[1]) lowest = entry;
  }
  return { name: lowest[0], score: lowest[1] };
}
